module.exports = __webpack_public_path__ + "img/flashlight.704c00d1.svg";